import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import Map from 'components/Map'
import MapHeader from 'components/MapHeader'
import MapLegends from 'components/MapLegends'
import { selectMapBaseUrl, selectMapZoomDelta, selectPlatform } from 'store/global'
import styles from './BusinessMap.scss'

export default function BusinessMap(props) {
  const { business: currentBusiness = {} } = props

  const mapBaseUrl = useSelector(selectMapBaseUrl)
  const mapZoomDelta = useSelector(selectMapZoomDelta)
  const platform = useSelector(selectPlatform)

  const { enrichedEmployeeLocations = [] } = currentBusiness
  const { businessGeopoints = [] } = currentBusiness
  const { adsGeopoints: marketingLocations = [] } = currentBusiness
  const { reviewsGeopoints = [] } = currentBusiness
  const { permitsGeos: permitsGeopoints = [] } = currentBusiness

  const legends = ['physical', 'employees', 'onlineMarketing', 'reviews', 'permits']

  return (
    <>
      <MapHeader type='business' {...props} />
      <div className={styles.legendContainer}>
        <MapLegends legends={legends} />
      </div>
      <div className={styles.container}>
        <Map
          platform={platform}
          baseUrl={mapBaseUrl}
          zoomDelta={mapZoomDelta}
          locations={[
            {
              list: enrichedEmployeeLocations,
              listColor: styles.employeeLocations,
            },
            {
              list: businessGeopoints,
              listColor: styles.physicalLocations,
            },
            {
              list: marketingLocations,
              listColor: styles.marketingLocations,
            },
            {
              list: reviewsGeopoints,
              listColor: styles.reviewLocations,
            },
            {
              list: permitsGeopoints,
              listColor: styles.permitLocations,
            },
          ]}
        />
      </div>
    </>
  )
}

BusinessMap.propTypes = {
  business: PropTypes.object,
  isExpanded: PropTypes.bool,
  onToggleExpand: PropTypes.func,
  onClose: PropTypes.func,
}
